'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableCard = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _recompose = require('recompose');

var _reactTransitionGroup = require('react-transition-group');

var _ExpandableCard = require('./ExpandableCard.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withToggle = (0, _recompose.withState)('expanded', 'toggleExpanded', false);
var withForceExpanded = (0, _recompose.mapProps)(function (props) {
  if ('forceExpanded' in props && props.forceExpanded !== undefined) {
    return (0, _extends3.default)({}, props, {
      expanded: props.forceExpanded
    });
  }
  return props;
});

var withToggleAndForceExpand = (0, _recompose.compose)(withToggle, withForceExpanded);

/*
* ExpandableCard component. Renders children above the fold, and renders the contents
* of props.hiddenSection when expanded.
*/
var ExpandableCard = exports.ExpandableCard = function ExpandableCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onCollapse = _ref.onCollapse,
      onExpand = _ref.onExpand,
      expanded = _ref.expanded,
      hiddenSection = _ref.hiddenSection,
      toggleExpanded = _ref.toggleExpanded;
  return _react2.default.createElement(
    'div',
    {
      className: className },
    _react2.default.createElement(
      'div',
      { className: 'row topRow' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-9' },
        children
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-xs-3 expandableToggle' },
        _react2.default.createElement('i', {
          className: 'fa-2x fa ' + (expanded ? 'fa-chevron-up' : 'fa-chevron-down'),
          onClick: function onClick() {
            toggleExpanded(!expanded);
            if (onExpand && !expanded) {
              onExpand();
            }
            if (onCollapse && expanded) {
              onCollapse();
            }
          }
        })
      )
    ),
    _react2.default.createElement(
      _reactTransitionGroup.TransitionGroup,
      null,
      expanded && _react2.default.createElement(
        _reactTransitionGroup.CSSTransition,
        {
          timeout: 200,
          classNames: 'vertical-grow' },
        hiddenSection
      )
    )
  );
};

ExpandableCard.propTypes = {
  /**
   * Capture to display
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Instrument that capture was created against
   */
  hiddenSection: _propTypes2.default.node.isRequired,
  /**
   * glamorous classname
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * Function called when collapsed
   */
  onCollapse: _propTypes2.default.func,

  /**
   * Function called when expanded
   */
  onExpand: _propTypes2.default.func,
  /**
   * Function called when edit is clicked
   */
  expanded: _propTypes2.default.bool,
  /**
   * Function called when edit is clicked
   */
  toggleExpanded: _propTypes2.default.func
};

exports.default = withToggleAndForceExpand((0, _glamorous2.default)(ExpandableCard)(_ExpandableCard.defaultStyle, _ExpandableCard.mapPropsAndThemeToStyle));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/cards/ExpandableCard/ExpandableCard.js
// module id = 381
// module chunks = 0